import OakLogo from "@/components/OakLogo";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";

export default function Privacy() {
  return (
    <div className="min-h-screen" data-testid="privacy-page">
      <nav className="max-w-5xl mx-auto px-6 py-5 flex items-center gap-3">
        <Link to="/" className="flex items-center gap-3"><OakLogo size={32} /><span className="font-display font-semibold">Oak AI Campus</span></Link>
      </nav>
      <main className="max-w-3xl mx-auto px-6 py-10 space-y-6 text-white/75 leading-relaxed">
        <div className="label-eyebrow">Legal</div>
        <h1 className="font-display text-4xl tracking-tight text-white">Privacy Policy</h1>
        <p className="text-white/55">Effective date: {new Date().toLocaleDateString()}</p>

        <Section title="Service provider">
          Oak AI Campus is owned and operated by <strong>Digiluxcon Technology Services (OPC)
          Private Limited</strong>, a company incorporated in India. References to "we", "our",
          or "us" in this policy mean Digiluxcon Technology Services (OPC) Private Limited.
        </Section>
        <Section title="What we collect">
          We collect your name, email, and profile picture from Google OAuth when you sign in. We store the learning paths, exams, and credit transactions you create.
        </Section>
        <Section title="How we use data">
          To run your account, generate personalized learning paths, grade exams, and manage credits. We never sell your data.
        </Section>
        <Section title="Data processors &amp; infrastructure">
          AI-driven learning paths and doubt-solving logic are processed via the
          <strong> Google Gemini API</strong> (Google LLC). Data storage is secured within the
          <strong> AWS Mumbai region (ap-south-1)</strong>, operated by Amazon Web Services. Your
          prompts and uploads are processed transiently for generation and are not used to train
          third-party models.
        </Section>
        <Section title="AI model usage">
          Goals, step details, and uploaded exam content are sent to Google Gemini for real-time
          generation. The model does not train on your data.
        </Section>
        <Section title="Payments & ads">
          Payments are processed by Razorpay (India) and Gumroad (International). Rewarded ads are simulated in V1. AdMob serving uses our registered <code className="font-mono-oak">app-ads.txt</code>.
        </Section>
        <Section title="Contact">
          Questions? Email <a className="text-[#8aa8ff]" href="mailto:info@oakaiapp.com">info@oakaiapp.com</a>.
        </Section>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="glass p-6">
      <h2 className="font-display text-xl tracking-tight text-white mb-2">{title}</h2>
      <p>{children}</p>
    </section>
  );
}
